import { useTheme } from '@mui/material/styles';
import { CUSTOM_LOADER } from '../../config/app-config';
import { CircularProgress } from "@mui/material";
import React from "react";

export default function Loader({
    widthCustom = '150px',
    marginCustom = null,
    marginDefault = '20px',
    sizeDefault = '70px',
}) {
    const theme = useTheme();
    if (CUSTOM_LOADER.enabled) {
        return (
            <img
                src={CUSTOM_LOADER.loader?.[theme.palette.mode]}
                alt="Loading Animation"
                style={{
                    width: widthCustom || '150px',
                    margin: marginCustom || '0px',
                    backgroundColor: 'transparent',
                }}
            />
        );
    }

    return (
        <CircularProgress
            size={sizeDefault}
            sx={{ color: 'progress.main', margin: marginDefault }}
        />
    );
}
